import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filter"
})
export class FilterSearchPipeAmm implements PipeTransform {
    
    transform(items: any[], filter: {[key: string]: string} ): any[] {
        if(!Object.keys(filter).length)
            return items;

        return items.filter(item => Object.keys(filter).some(keyName => new RegExp(filter[keyName], 'gi').test(item[keyName]) || filter[keyName] == ""));
    }
    
}